import ServicesClientTab from 'admin/features/clients/viewClientDetails/servicesClientTab';
import { UserRoleEnum } from 'app/services/user';
import { lazy } from './lazyWithRetry';
import { Navigate, Route } from 'react-router-dom';
import { ProtectedRoleRoute } from 'utils/RequireAuth';
import MessagesRoutes from './MessagesRoutes';
import { suspense } from './utils';
import BusinessesRoutes from './BusinessesRoutes';
import EditAccountInfo from 'app/features/profile/accountInfo/editAccountInfo';
import ChangePassword from 'app/features/profile/changePassword';
import ViewPersonalDetails from 'app/features/profile/personalDetails/viewPersonalDetails';
import EditPersonalDetails from 'app/features/profile/personalDetails/editPersonalDetails';
import { TaxEstimates } from 'app/features/taxEstimates';
import TaxEstimatesRoutes from './TaxEstimatesRoutes';
import { TaxExtensions } from 'app/features/taxExtensions';
import TaxExtensionsRoutes from './TaxExtensionsRoutes';
import { FincenReports } from 'app/features/fincenReports';
import FincenReportsRoutes from './FincenReportsRoutes';

const ClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails'),
);

const AccountInfoClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails/accountInfoClientTab'),
);

const DocumentsClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails/documentsClientTab'),
);
const PersonalDetailsClientTab = lazy(
  () =>
    import('admin/features/clients/viewClientDetails/personalDetailsClientTab'),
);
const TasksClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails/tasksClientTab'),
);

const SMSClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails/SMSClientTab'),
);
const TaxReturnsClientTab = lazy(
  () => import('admin/features/clients/viewClientDetails/taxReturnsClientTab'),
);

const ShowQuestionnaire = lazy(
  () => import('app/features/questionnaires/show'),
);

const TaskDetails = lazy(
  () => import('app/features/tasks/ShowTask/TaskDetails'),
);

export default function ClientDetailsRoutes() {
  return (
    <>
      <Route path="clients/:clientId" element={suspense(<ClientTab />)}>
        <Route path="" element={<Navigate replace to="account" />} />
        <Route path="account">
          <Route path="" element={<AccountInfoClientTab />} />
          <Route path="edit" element={<EditAccountInfo />} />
          <Route element={<ProtectedRoleRoute roles={[UserRoleEnum.CLIENT]} />}>
            <Route path="changePassword" element={<ChangePassword />} />
          </Route>
        </Route>
        <Route path="personalDetails">
          <Route path="" element={<ViewPersonalDetails />} />
          <Route path="edit" element={<EditPersonalDetails />} />
        </Route>

        {BusinessesRoutes()}
        {TaxEstimatesRoutes()}
        {TaxExtensionsRoutes()}
        {FincenReportsRoutes()}
        <Route path="Documents" element={suspense(<DocumentsClientTab />)} />
        <Route path="Tasks" element={suspense(<TasksClientTab />)} />
        <Route path="Tasks/:taskId" element={suspense(<TaskDetails />)} />
        <Route path="TaxReturns" element={suspense(<TaxReturnsClientTab />)} />
        <Route path="taxEstimates" element={<TaxEstimates />} />
        <Route path="taxExtensions" element={<TaxExtensions />} />
        <Route path="fincenReports" element={<FincenReports />} />
        <Route
          path="TaxReturns/:questionnaireId/preview"
          element={suspense(<ShowQuestionnaire preview={true} />)}
        />
        <Route path="SMS" element={suspense(<SMSClientTab />)} />

        {MessagesRoutes()}

        <Route
          path=""
          element={<ProtectedRoleRoute roles={[UserRoleEnum.ADMIN]} />}
        >
          <Route path="Services" element={suspense(<ServicesClientTab />)} />
        </Route>
      </Route>
    </>
  );
}
